/**
 * Widget Index Mapping Utilities
 *
 * Converts a visible/home-widget index into the exact
 * index inside Redux `data.widgets`.
 *
 * Matching priority:
 *
 * 1. Unique ID
 * 2. Object reference
 * 3. Type + occurrence
 *
 * IMPORTANT:
 * We never use type alone because multiple widgets
 * can have the same type.
 */

export function getWidgetIndexForOperation(
  visibleIndex: number,
  visibleWidgets: any[],
  storeWidgets: any[],
): number {
  if (
    !Array.isArray(visibleWidgets) ||
    !Array.isArray(storeWidgets)
  ) {
    return -1;
  }

  if (
    visibleIndex < 0 ||
    visibleIndex >= visibleWidgets.length
  ) {
    return -1;
  }

  const targetWidget = visibleWidgets[visibleIndex];

  if (!targetWidget) {
    return -1;
  }

  // ==================================================
  // 1. MATCH BY ID
  // ==================================================

  if (targetWidget?.id) {
    const indexById = storeWidgets.findIndex(
      (widget: any) =>
        widget?.id === targetWidget.id,
    );

    if (indexById !== -1) {
      return indexById;
    }
  }

  // ==================================================
  // 2. MATCH BY OBJECT REFERENCE
  // ==================================================

  const indexByReference =
    storeWidgets.findIndex(
      (widget: any) =>
        widget === targetWidget,
    );

  if (indexByReference !== -1) {
    return indexByReference;
  }

  // ==================================================
  // 3. MATCH BY TYPE + OCCURRENCE
  // ==================================================

  if (targetWidget?.type) {
    const targetType = targetWidget.type;

    let targetOccurrence = 0;

    for (
      let i = 0;
      i < visibleIndex;
      i++
    ) {
      if (
        visibleWidgets[i]?.type ===
        targetType
      ) {
        targetOccurrence++;
      }
    }

    let currentOccurrence = 0;

    for (
      let i = 0;
      i < storeWidgets.length;
      i++
    ) {
      if (
        storeWidgets[i]?.type ===
        targetType
      ) {
        if (
          currentOccurrence ===
          targetOccurrence
        ) {
          return i;
        }

        currentOccurrence++;
      }
    }
  }

  // ==================================================
  // NO MATCH
  // ==================================================

  return -1;
}